import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Box from "@mui/material/Box";
import Skeleton from "@mui/material/Skeleton";
import SlideInModal from "components/base/SlideInModal2/SlideInModal";
import Typography from "@mui/material/Typography";
//import { styled } from "@mui/material/";
import { ReactComponent as Close } from "assets/svg/close.svg";
import { styles2 } from "./TransactionsTable.styles";
//import { ReactComponent as InfoIcon } from "assets/svg/info.svg";
//import { ReactComponent as SortIcon } from "assets/svg/sort.svg";
import { Button /* styled */ /* TextField */ } from "@mui/material";
import { formatCurrency } from "utils/formatCurrency";
import { styles } from "./TransactionsTable.styles";
import { useState } from "react";
import InputWithLabel from "components/base/InputWithLabel/InputWithLabel";
import { completeRequestBills, sendOtpReq } from "services/corporateDashboard";
//import { updateTransReq } from "services/corporateDashboard";
//import { useQuery } from "@tanstack/react-query";
import { useMutation } from "@tanstack/react-query";

import Stack from "@mui/material/Stack";
//import DirectionSnackbar from "components/base/SnackBar/SnackBar";
import { useFormik } from "formik";
//import { styles as styles2 } from "components/SavedBeneficiaries/AddNewCitmfbBeneficiaryModal/AddNewCitmfbBeneficiaryModal.styles";
import OTP from "components/base/OTP/OTP";
import TransactionSuccessful from "components/base/TransactionSuccessful/TransactionSuccessful";

const TransactionsTable = ({ data, dataHead, loading }) => {
  const [open, setOpen] = useState(false);
  const [open2, setOpen2] = useState(false);
  const [open3, setOpen3] = useState(false);
  const [reason, setReason] = useState("");
  const [current, setCurrent] = useState("");
  //const [transaction, setTransaction] = useState("");
  const [step, setStep] = useState(0);
  // const [openError, setOpenError] = useState(false);
  //const [error, setError] = useState("");
  const formik = useFormik({
    initialValues: {
      otp: "",
    },
  });

  const {
    mutate: SendOtpReq,
    isLoading: reqOtp,
    data: otpData,
  } = useMutation({
    mutationFn: sendOtpReq,
    onSuccess: (data) => {
      console.log(data, otpData);
      setStep(1);
    },
    onError: (err) => {
      console.log(err);
    },
  });

  const handleSendOtpReq = () => {
    SendOtpReq();
  };

  const { mutate, isLoading } = useMutation({
    mutationFn: completeRequestBills,
    onSuccess: (data) => {
      console.log(data);
      setStep(2);
      handleClose(false);
      handleClose2(false);
    },
  });

  const handleOpen = () => setOpen(true);
  const handleOpen2 = () => setOpen2(true);
  const handleOpen3 = () => setOpen3(true);

  const handleClose = () => {
    setOpen(false);
  };
  const handleClose2 = () => {
    setOpen2(false);
  };
  const handleClose3 = () => {
    setOpen3(false);
    setStep(0);
  };

  const rowData = data;
  const [trans, setTrans] = useState("");

  let transs = trans;

  console.log(transs);
  return (
    <TableContainer component={Box} mt={2}>
      <Table
        sx={{ minWidth: { xs: "max-content", lg: 650 } }}
        aria-label="table"
      >
        <TableHead>
          <TableRow
            sx={{ ...styles.tableHeader, "th, td": { border: "none", py: 1 } }}
          >
            {/*  <TableCell sx={styles.headerText}>
              DATE <SortIcon style={{ verticalAlign: "middle" }} />
            </TableCell> */}

            {dataHead?.map((item) => {
              return (
                <TableCell sx={styles.headerText}>
                  {item}
                  {/* <Info /> */}
                </TableCell>
              );
            })}
          </TableRow>
        </TableHead>
        <TableBody>
          {rowData?.map((row, index) => (
            <TableRow
              key={index}
              sx={{
                "&:nth-of-type(even)": {
                  bgcolor: "rgba(247, 249, 252, 0.8)",
                },
                "&:last-child td, &:last-child th": { border: 0 },
                "th, td": { border: "none" },
              }}
            >
              <TableCell
                component="th"
                scope="row"
                sx={{
                  ...styles.contentText,
                  ...styles.textColor("green3.main"),
                }}
              >
                {loading ? (
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: { xs: 100, lg: "auto" },
                      height: 20,
                      transform: "none",
                    }}
                  />
                ) : (
                  //new Date(row.beneficiary_name).toDateString().slice(4)
                  "+" + row?.beneficiary
                )}
              </TableCell>
              <TableCell sx={styles.contentText}>
                {loading ? (
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: { xs: 100, lg: "auto" },
                      height: 20,
                      transform: "none",
                    }}
                  />
                ) : (
                  row?.network || "KC Microfinance Bank"
                )}
              </TableCell>
              {/* <TableCell sx={styles.contentText}>{row.account}</TableCell> */}
              <TableCell sx={styles.contentText}>
                {loading ? (
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: { xs: 100, lg: "auto" },
                      height: 20,
                      transform: "none",
                    }}
                  />
                ) : (
                  row?.account_no
                )}
              </TableCell>

              <TableCell sx={styles.contentText}>
                {loading ? (
                  <Skeleton
                    variant="rounded"
                    sx={{
                      width: { xs: 100, lg: "auto" },
                      height: 20,
                      transform: "none",
                    }}
                  />
                ) : (
                  formatCurrency(Number(row?.amount))
                )}
              </TableCell>
              {row?.status === "declined" ? (
                ""
              ) : (
                <TableCell
                  sx={{
                    ...styles.contentText,
                    ...styles.textColor(
                      row.type === "Credit" ? "green3.main" : "red.main"
                    ),
                  }}
                >
                  {loading ? (
                    <Skeleton
                      variant="rounded"
                      sx={{
                        width: { xs: 100, lg: "auto" },
                        height: 20,
                        transform: "none",
                      }}
                    />
                  ) : (
                    <Button
                      variant="contained"
                      sx={{
                        width: { xs: "fit-content" },
                        bgcolor: "rgba(45, 202, 114, 0.2)",
                        color: "rgb(45, 202, 113)",
                        fontSize: { xs: 6, lg: 10 },
                        fontWeight: 600,
                        boxShadow: "none",
                        alignSelf: { xs: "flex-end", sm: "auto" },
                        "&:hover": { bgcolor: "rgba(45, 202, 114, 0.2)" },
                      }}
                      onClick={() => {
                        setTrans(row?.id);
                        handleOpen();
                        setCurrent("approve");
                      }}
                    >
                      APPROVE
                    </Button>
                  )}
                </TableCell>
              )}
              {row?.status === "declined" ? (
                ""
              ) : (
                <TableCell
                  sx={{
                    ...styles.contentText,
                    ...styles.textColor(
                      row.type === "Credit" ? "green3.main" : "red.main"
                    ),
                  }}
                >
                  {loading ? (
                    <Skeleton
                      variant="rounded"
                      sx={{
                        width: { xs: 100, lg: "auto" },
                        height: 20,
                        transform: "none",
                        background: "green3.main",
                      }}
                    />
                  ) : (
                    <Button
                      variant="contained"
                      sx={{
                        width: { xs: "fit-content" },
                        bgcolor: "rgba(202, 45, 45, 0.2)",
                        color: "rgb(202, 45, 45)",
                        fontSize: { xs: 6, lg: 10 },
                        fontWeight: 600,
                        boxShadow: "none",
                        alignSelf: { xs: "flex-end", sm: "auto" },
                        "&:hover": { bgcolor: "rgba(202, 45, 45, 0.2)" },
                      }}
                      onClick={() => {
                        setTrans(row?.id);
                        handleOpen2();
                        setCurrent("decline");
                      }}
                    >
                      DECLINE
                    </Button>
                  )}
                </TableCell>
              )}
            </TableRow>
          ))}
        </TableBody>

        <SlideInModal open={open} handleClose={handleClose}>
          <Typography onClick={handleClose} sx={styles2.closeX}>
            <Close sx={styles2.closeIcon} />
          </Typography>
          <Box my="4px">
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="4" y="4" width="48" height="48" rx="24" fill="#C8FFE0" />
              <path
                d="M23 19V22.4C23 22.9601 23 23.2401 23.109 23.454C23.2049 23.6422 23.3578 23.7951 23.546 23.891C23.7599 24 24.0399 24 24.6 24H31.4C31.9601 24 32.2401 24 32.454 23.891C32.6422 23.7951 32.7951 23.6422 32.891 23.454C33 23.2401 33 22.9601 33 22.4V20M33 37V30.6C33 30.0399 33 29.7599 32.891 29.546C32.7951 29.3578 32.6422 29.2049 32.454 29.109C32.2401 29 31.9601 29 31.4 29H24.6C24.0399 29 23.7599 29 23.546 29.109C23.3578 29.2049 23.2049 29.3578 23.109 29.546C23 29.7599 23 30.0399 23 30.6V37M37 25.3255V32.2C37 33.8802 37 34.7202 36.673 35.362C36.3854 35.9265 35.9265 36.3854 35.362 36.673C34.7202 37 33.8802 37 32.2 37H23.8C22.1198 37 21.2798 37 20.638 36.673C20.0735 36.3854 19.6146 35.9265 19.327 35.362C19 34.7202 19 33.8802 19 32.2V23.8C19 22.1198 19 21.2798 19.327 20.638C19.6146 20.0735 20.0735 19.6146 20.638 19.327C21.2798 19 22.1198 19 23.8 19H30.6745C31.1637 19 31.4083 19 31.6385 19.0553C31.8425 19.1043 32.0376 19.1851 32.2166 19.2947C32.4184 19.4184 32.5914 19.5914 32.9373 19.9373L36.0627 23.0627C36.4086 23.4086 36.5816 23.5816 36.7053 23.7834C36.8149 23.9624 36.8957 24.1575 36.9447 24.3615C37 24.5917 37 24.8363 37 25.3255Z"
                stroke="#27490F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                stroke="#EDFFF5"
                stroke-width="8"
              />
            </svg>
          </Box>

          <Typography sx={styles2.desc}>
            Are you sure you want to approve this transaction?
          </Typography>

          <Box
            sx={{
              display: "flex",
              mt: "10px",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="outlined"
              fullWidth
              sx={{
                color: "#000",
                border: "1px solid #dadada",
                ...styles2.closeBtn,
              }}
              onClick={handleClose2}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              fullWidth
              sx={{
                color: "white",
                backgroundColor: "green3.main",
                ...styles2.closeBtn,
              }}
              onClick={() => {
                handleOpen3();
                handleClose();
              }}
            >
              Confirm
            </Button>
          </Box>
        </SlideInModal>
        {/* CLOSE MODAL */}

        <SlideInModal open={open2} handleClose={handleClose2}>
          <Typography onClick={handleClose2} sx={styles2.closeX}>
            <Close sx={styles2.closeIcon} />
          </Typography>
          <Box my="4px">
            <svg
              width="56"
              height="56"
              viewBox="0 0 56 56"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <rect x="4" y="4" width="48" height="48" rx="24" fill="#C8FFE0" />
              <path
                d="M23 19V22.4C23 22.9601 23 23.2401 23.109 23.454C23.2049 23.6422 23.3578 23.7951 23.546 23.891C23.7599 24 24.0399 24 24.6 24H31.4C31.9601 24 32.2401 24 32.454 23.891C32.6422 23.7951 32.7951 23.6422 32.891 23.454C33 23.2401 33 22.9601 33 22.4V20M33 37V30.6C33 30.0399 33 29.7599 32.891 29.546C32.7951 29.3578 32.6422 29.2049 32.454 29.109C32.2401 29 31.9601 29 31.4 29H24.6C24.0399 29 23.7599 29 23.546 29.109C23.3578 29.2049 23.2049 29.3578 23.109 29.546C23 29.7599 23 30.0399 23 30.6V37M37 25.3255V32.2C37 33.8802 37 34.7202 36.673 35.362C36.3854 35.9265 35.9265 36.3854 35.362 36.673C34.7202 37 33.8802 37 32.2 37H23.8C22.1198 37 21.2798 37 20.638 36.673C20.0735 36.3854 19.6146 35.9265 19.327 35.362C19 34.7202 19 33.8802 19 32.2V23.8C19 22.1198 19 21.2798 19.327 20.638C19.6146 20.0735 20.0735 19.6146 20.638 19.327C21.2798 19 22.1198 19 23.8 19H30.6745C31.1637 19 31.4083 19 31.6385 19.0553C31.8425 19.1043 32.0376 19.1851 32.2166 19.2947C32.4184 19.4184 32.5914 19.5914 32.9373 19.9373L36.0627 23.0627C36.4086 23.4086 36.5816 23.5816 36.7053 23.7834C36.8149 23.9624 36.8957 24.1575 36.9447 24.3615C37 24.5917 37 24.8363 37 25.3255Z"
                stroke="#27490F"
                stroke-width="2"
                stroke-linecap="round"
                stroke-linejoin="round"
              />
              <rect
                x="4"
                y="4"
                width="48"
                height="48"
                rx="24"
                stroke="#EDFFF5"
                stroke-width="8"
              />
            </svg>
          </Box>

          <Typography sx={styles2.desc}>
            Are you sure you want to decline this transaction?
          </Typography>

          <InputWithLabel>
            <textarea
              style={{
                width: "100%",
                height: "200px",
                my: "20px",
                outline: "none",
                border: "1px dashed",
                borderRadius: "10px",
              }}
              onChange={(e) => {
                setReason(e.target.value);
              }}
            ></textarea>
          </InputWithLabel>

          <Box
            sx={{
              display: "flex",
              mt: "10px",
              justifyContent: "space-between",
            }}
          >
            <Button
              variant="outlined"
              fullWidth
              sx={{
                color: "#000",
                border: "1px solid #dadada",
                ...styles2.closeBtn,
              }}
              onClick={handleClose2}
            >
              Cancel
            </Button>

            <Button
              variant="contained"
              fullWidth
              sx={{
                color: "white",
                backgroundColor: "rgb(202, 45, 45)",
                ...styles2.closeBtn,
              }}
              onClick={() => {
                handleOpen3();
                handleClose2();
              }}
            >
              Decline
            </Button>
          </Box>
        </SlideInModal>

        <SlideInModal
          sx={{ display: "grid", placeItems: "center" }}
          open={open3}
          handleClose={handleClose3}
        >
          {/* <DirectionSnackbar
            open={open.error}
            handleClose={() => handleClose("error")}
            message={"error"}
            direction={{ vertical: "top", horizontal: "center" }}
          /> */}

          <Box sx={styles.container} as="form">
            {step === 0 && (
              <Stack spacing={3} sx={styles.content} alignItems="center">
                <Typography sx={styles.header}>Request for OTP</Typography>
                <Button
                  variant="contained"
                  color="green3"
                  sx={styles.btn}
                  disabled={reqOtp}
                  onClick={handleSendOtpReq}
                >
                  {reqOtp ? "Please wait" : "Send Request"}
                </Button>
              </Stack>
            )}
            {step === 1 && (
              <>
                <Stack spacing={3} sx={styles.content} alignItems="center">
                  <Typography sx={styles.header}>Update Transaction</Typography>
                  {data?.detail}
                  <InputWithLabel label="OTP Pin">
                    <OTP
                      formik={formik}
                      formikKey="otp"
                      variant={2}
                      length={6}
                    />
                  </InputWithLabel>

                  <Box sx={{ height: 10 }} />

                  <Box mx="auto" width="fit-content" mt={{ xs: 3, sm: 5 }}>
                    <Button
                      variant="contained"
                      color="green3"
                      sx={styles.btn}
                      disabled={isLoading}
                      onClick={() => {
                        if (current === "approve") {
                          mutate({
                            action: "approve",
                            payment_type: "data",
                            otp: formik.values.otp,
                            id: transs,
                          });
                        } else {
                          mutate({
                            action: "decline",
                            payment_type: "data",
                            otp: formik.values.otp,
                            reason: reason,
                            id: transs,
                          });
                        }
                      }}
                    >
                      {isLoading ? "Please wait" : "Submit"}
                    </Button>
                  </Box>
                </Stack>
              </>
            )}
          </Box>
          {step === 2 && (
            <TransactionSuccessful
              title={
                (localStorage.getItem("level") === "1" &&
                  "Data Payment has been Updated, waiting for Verification") ||
                (localStorage.getItem("level") === "2" &&
                  "Data Payment has been Updated, waiting for Approval") ||
                (localStorage.getItem("level") === "3" &&
                  "Data Payment has been Sent Out")
              }
              handleClick={() => {
                setStep(0);
                handleClose();
                handleClose3();
                handleClose2();
                handleClose();
              }}
            />
          )}
        </SlideInModal>
      </Table>
    </TableContainer>
  );
};

export default TransactionsTable;
